import { node } from "~/util/dom";
import Content from "./content";
import { _ } from "~/i18n";
import { CONFIG } from "~/config";
import { IPoi } from "~/interfaces";
import { store } from "~/state/store";
import { unsetDetail } from "~/state/detail/state";

/**
 * @class Vytváří položku obsahu vizitky - POILink
 * @private
 */
export default class POILink extends Content {
	// @ts-ignore
	_options: {
		detailData?: IPoi;
		type: "" | "twin";
	};

	_build() {
		this._dom.container.classList.add("content-link", "poilink");

		let data: Array<any> = null;
		let addTitle = false;

		if (this._data) {
			if (Array.isArray(this._data)) {
				data = this._data;
			} else {
				data = this._data.value;
			}

			for (let ind = 0, len = (data || []).length; ind < len; ind++) {
				const item = data[ind];

				if (item.type && item.type === "twin" && this._options.type === "twin") {
					this._dom.container.insertAdjacentHTML("beforeend", `<a target="_blank" href="//www.firmy.cz/detail/${item.id}">${_("detail.content.poilink.firmLink")}</a>`);
				/* souvisejici POIe*/
				} else if (!item.type && !this._options.type) {
					if (!addTitle) {
						this._dom.container.innerHTML = `<strong>${_("detail.content.poilink.relatedPoints")}:</strong>`;
						this._activateRelatedPoilink();

						addTitle = true;
					}

					const link = node("a", { href: `https://${CONFIG.BASE_URL}/?source=${item.source}&id=${item.id}`, innerHTML: item.title });

					link.setAttribute("title", item.title);
					link.setAttribute("data-trg-source", item.source);
					link.setAttribute("data-trg-id", item.id);
					link.setAttribute("data-log-action", "click");
					link.setAttribute("data-log-type", "poilink");

					// middle click - otevrit v novem okne
					link.addEventListener("click", event => {
						if (Mapy.Util.linkToNewWindow(event)) {
							// middle click
							event.stopPropagation();
						}
					});
					this._dom.container.append(link);
				}
			}
		}

		if (this._options.detailData?.seolinks) {
			if (!addTitle) {
				this._dom.container.innerHTML = `<strong>${_("detail.content.poilink.relatedPoints")}:</strong>`;
			}

			for (const seoLink of this._options.detailData.seolinks) {
				const link = node("a", { href: `https://${CONFIG.BASE_URL}/?q=${encodeURIComponent(seoLink.title)}`, innerHTML: seoLink.title });

				link.addEventListener("click", event => {
					event.preventDefault();
					event.stopPropagation();
					Mapy.getComponent("search").activate();
					Mapy.getComponent("search").setState({
						q: seoLink.title,
					});
					store.dispatch(unsetDetail());
					Mapy.getComponent("history").save();
				});

				this._dom.container.append(link);
			}
		}

		if (!this._dom.container.childNodes.length) {
			this._dom.container.classList.add("empty");
		}
	}

	/* aktivace souvisejicich POIu */
	_activateRelatedPoilink() {
		this._dom.container.addEventListener("click", event => {
			const target = event.target as HTMLElement;

			/* click na souvisejici POI */
			if (target.nodeName.toLowerCase() === "a") {
				event.preventDefault();
				event.stopPropagation();

				const id = target.getAttribute("data-trg-id");
				const source = target.getAttribute("data-trg-source");

				Mapy.getComponent("detail").setState({ source: source, id: id, show: true }).then(() => {
					Mapy.getComponent("history").save();
				}, () => {});
			}
		});
	}
}
